<template>
	<div>
		<BusinessBanner />
		<div class="content-zsy">
			<InventoryNavi />
			<div class="document-inventory-guide">
				<div class="title-wrap">
					<h3>재고/보관</h3>
					<h4>재고/보관 서비스 안내</h4>
				</div>
				<div class="info-area mb60">
					<div class="head mb20">재고/보관 서비스란?</div>
					<div class="body">
						물품보관, 재고관리 등 복잡하고 비용이 부담이 되는 <br class="visible-xs">업무를 고로켓고에 맡기고 판매에만 집중하세요.<br>
						중국 판매자로부터 구매하신 상품을 <br class="visible-xs">고로켓고 중국 현지 센터에 재고보관하여<br>
						사업자 회원님의 고객 주문 시 수령지로 <br class="visible-xs">발송해드리는 서비스입니다.
					</div>
				</div>
				
			</div>
			<div class="type-card shadow-all mb20">
				<div class="card-head">1. 재고관리 장점</div>
				<div class="card-body">
					<div class="title">1. 상품관리</div>
					<ul class="dot-list mb30">
						<li>● 고로켓고 중국센터의 안전한 보안 시스템으로 상품 안심보관이 가능합니다.</li>
						<li>● 판매 성적이 우수한 상품의 선제적 재고보관으로 판매 경쟁력 확보</li>
						<li>● 고로켓고 재고 보관 관리 시스템을 통해 정확한 입출고 내역 및 발송 현황 확인으로 체계적인 판매계획 수립가능이 가능합니다.</li>
					</ul>
					<div class="title">2. 시간관리</div>
					<ul class="dot-list">
						<li>● 재고/보관된 상품은 현지 배송기간이 소요되지 않기에 전체 배송기간을 줄일 수 있습니다.</li>
						<li>● 재보관된 상품은 당일 신청 시 당일 출고 가능 (당일 오전 9시까지 결제된 건 기준)</li>
					</ul>
				</div>		
			</div>
			<div class="type-card shadow-all mb20">
				<div class="card-head">2. 이용안내</div>
				<div class="card-body">
					<ul class="dot-list">
						<li>● 이용조건 : 사업자 회원 무료</li>
						<li>● 전자상거래통관(개인통관부호/사업자번호) 이용 구매대행 사업자만 재고/보관 이용 가능하며<br>※ 최소 등록 수량 : 5개부터 이용가능</li>
						<li>● 고로켓고 재고 보관 관리 시스템을 통해 정확한 입출고 내역 및 발송 현황 확인으로 체계적인 판매계획 수립가능이 가능합니다.</li>
					</ul>
				</div>		
			</div>
			<div class="type-card shadow-all mb60">
				<div class="card-head">3. 이용방법</div>
				<div class="card-body">
					<div class="unit mb30">
						<div class="title mb5"><strong>1. 입고할 상품 등록</strong></div>
						<p class="mb30 background-color">먼저 상품관리의 상품등록 메뉴에서 입고할 상품을 등록합니다. 등록옵션이 다양할 경우 엑셀 파일 양식으로 등록하실 수 있습니다.</p>
						<div class="img-box">
							<img src="../../assets/list/document_inventory_guide_img1.png" alt="" class="img-responsive">
		
							<!-- <img v-if="!isMobile" src="../../assets/list/document_inventory_guide_img1.jpg" alt="" class="img-responsive">
							<img v-else src="../../assets/list/document_inventory_guide_m_img1.png" alt="" class="img-responsive"> -->
						</div>
					</div>
					<div class="divided-line type-solid mb30"></div>
					<div class="unit mb30">
						<div class="title mb5"><strong>2. 등록 상품의 입고신청</strong></div>
						<p class="mb30 background-color">
							상품 등록 완료 후, 실제 입고될 상품의 경우에는 바로 입고 신청을 해주십시오. <span class="main-color">(신청없이 상품이 먼저 도착하면 입고불가)</span><br>
							입고관리의 입고신청 메뉴로 이동합니다.<br>
							입고 상품의 오더넘버, 트래킹넘버, 정확한 수량을 입력하신 후 등록하기 버튼을 누릅니다.
						</p>
						<div class="img-box">
							<img src="../../assets/list/document_inventory_guide_img2.png" alt="" class="img-responsive">
							
						</div>
					</div>
					<div class="divided-line type-solid mb30"></div>
					<div class="unit mb30">
						<div class="title mb30"><strong>3. 입고신청 등록과 동시에 입고현황 목록에 추가되며, 상태 확인 및 수정을 하실 수 있습니다.</strong></div>
						<div class="img-box">
							<img src="../../assets/list/document_inventory_guide_img3.png" alt="" class="img-responsive">
			
						</div>
					</div>
					<div class="divided-line type-solid mb30"></div>
					<div class="unit mb30">
						<div class="title mb5"><strong>4. 입고된 상품의 발송신청</strong></div>
						<p class="mb30 background-color">
							입고가 완료된 상품은 발송신청을 통해 발송하실 수 있습니다. 발송관리의 발송신청 메뉴로 이동합니다.<br>
							상품을 받으실 수취인 정보를 정확하게 입력하신 후 발송할 상품의 수량을 입력하고 등록버튼을 눌러 신청을 완료합니다.
						</p>
						<div class="img-box">
							<img src="../../assets/list/document_inventory_guide_img4.png" alt="" class="img-responsive">
			<!-- 				<img src="../../assets/list/document_inventory_guide_img4.jpg" alt="" class="img-responsive hidden-xs">
							<img src="../../assets/list/document_inventory_guide_m_img3.png" alt="" class="img-responsive visible-xs"> -->
						</div>
					</div>
					<div class="divided-line type-solid mb30"></div>
					<!-- <div class="unit mb30">
						<div class="title mb30"><strong>5. 재고현황에서 10개의 입고상품 중 1개가 발송신청 되었음을 확인하실 수 있습니다.</strong></div>
						<div class="img-box">
							<img src="../../assets/list/document_inventory_guide_img5.jpg" alt="" class="img-responsive hidden-xs">
							<img src="../../assets/list/document_inventory_guide_m_img4.png" alt="" class="img-responsive visible-xs">
						</div>
					</div> -->
					
				</div>
			</div>
			<div class="caution">
				<h6>주의사항</h6>
				<ul class="check-list">
					<li>수량 체크는 입고 처리 기준 평일 1일 이내에 완료, 수량이 많을 경우 지연될 수 있습니다.</li>
					<li>재보관된 상품은 당일 신청 시 당일 출고 가능 (당일 오전 9시까지 결제된 건 기준)</li>
					<li>출고일 기준 최소 2일 전에 미리 입고 바라며, 급하게 발송해야 하는 품목은 재고가 아닌 신청서로 등록 바랍니다.</li>
					<li>재고 신청서가 작성되지 않은 상태에서 노데이터로 입고되면, 사서함 별도 보관 후 처리되기 때문에 입고 수량 등록이 지연됩니다.</li>
					<li>신청서는 입고 수량을 기준으로 작성하실 수 있습니다.</li>
					<li>엑셀 등록일 경우, 입고 수량 확인 전 등록이 가능합니다.</li>
					<li>재고보관기간은 마지막 입고된 상품의 입고일부터 3개월간 무료이며 기한이 지난 제품들은 따로 통보하지 않고 전량 폐기됩니다.</li>
				</ul>
			</div>
			
			
		</div>
		
	</div>
</template>

<script>
	import BusinessBanner from '../../components/BusinessBanner.vue'
	import InventoryNavi from '../../components/InventoryNavi.vue'
	export default {
		components: {
			BusinessBanner,
			InventoryNavi
		},
		data() {
			return{
				
			}
		},
		computed: {
			isMobile() {
			  return window.innerWidth <= 768;
			}
		},		
		methods: {

		}
	
	}
</script>

<style scoped>
	.document-inventory-guide {
	    max-width: 800px;
	    margin: 0 auto;
	}
	.title-wrap{
		text-align: center;
		color: var(--frontground-color);
		margin-bottom: 60px;
	}
	.title-wrap h3 {
	    font-size: 20px;
	    font-weight: bold;
	    color: var(--main-color);
	    margin: 0 0 19px;
	}
	.title-wrap h4 {
	    font-weight: 700;
	    font-size: 36px;
	    line-height: 1.34;
	    margin: 0;
	}
	.document-inventory-guide .info-area {
	    text-align: center;
	    color: var(--frontground-color);
	}
	.document-inventory-guide .info-area .head {
	    font-weight: 700;
	    font-size: 30px;
	    line-height: 36px;
	}
	.document-inventory-guide .info-area .body {
	    font-size: 17px;
	    line-height: 1.8;
	}
	.type-card.shadow-all {
	    border: none;
	    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
		border-radius: 26px;
		overflow: hidden;
	}
	.type-card > .card-head {
	    font-weight: 700;
	    font-size: 20px;
	    height: 66px;
	    line-height: normal;
	    display: flex;
	    align-items: center;
	    justify-content: center;
	    color: #fff;
	    gap: 0 8px;
	    background: #303030;
	}
	.type-card > .card-body {
	    padding: 50px;
	    background: #fff;
	}
	.card-body .title {
	    font-weight: bold;
	    font-size: 18px;
	    color: #111111;
	}
	ul.dot-list {
	    margin: 0;
	    padding: 0;
	    list-style: none;
	}
	.card-body .dot-list > li {
		font-size: 17px;
		color: #111111;
		padding:3px 0;
 	}
/*	ul.dot-list > li:before {
	    content: '';
	    display: block;
	    position: absolute;
	    top: 12px;
	    left: 0;
	    width: 6px;
	    height: 6px;
	    background: var(--main-color);
	    border-radius: 50%;
	} */
	.type-card .divided-line.type-solid {
	    border-top-style: solid;
	}
	.type-card .divided-line {
	    border-top: 1px dashed var(--border-color);
	    margin: 26px 0;
	}
	.type-card .img-box {
	    display: flex;
	    justify-content: center;
	}
	.img-responsive {
	    display: block;
	    max-width: 100%;
	    height: auto;
	}
	
	.caution{
		padding:0 10px 30px;
	}
	.caution h6 {
	    font-weight: 700;
	    font-size: 17px;
	    line-height: 20px;
	    color: #111111;
	    margin: 0 0 10px;
	}
	ul.check-list {
	    margin: 0;
	    padding: 0;
	    list-style: none;
	}
	ul.check-list li {
	    padding-left: 26px;
	    background: url('../../assets/ico_check_grey.svg') no-repeat left 2px top 4px;
	    font-weight: 400;
	    font-size: 15px;
	    line-height: 25px;
	}
	
	.main-color {
	    color: var(--main-color);
	}
	.mb20 {
	    margin-bottom: 20px !important;
	}
	.mb30 {
	    margin-bottom: 30px !important;
	}
	.mb60 {
	    margin-bottom: 60px !important;
	}
	.visible-xs {
	    display: none !important;
	}
	.background-color{
		color: var(--background-color);
	}
	@media (min-width: 992px) {
		.content-zsy{
			width: 800px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.title-wrap{
			margin-top: 20px;
		}
		.title-wrap h3 {
			font-size: 18px;
			color: #0055D4;
			font-weight: bold;
			line-height: 23px;
		}
		.title-wrap h4 {
			font-weight: 700;
			font-size: 30px;
			line-height: 39px;
			text-align: center;
		}
		.type-card{
			margin: 0 10px;
		}
		.type-card > .card-body {
		    padding: 26px;
		    background: #fff;
		}
		
		.visible-xs {
		    display:block !important;
		}
		.hidden-xs {
			display: none !important;
		}
	}
</style>